const F = "CONNECT", A = "DEFAULT";
var D = /* @__PURE__ */ ((o) => (o.GET_STATE = "get-state", o.GET_STATE_RESPONSE = "get-state-response", o.SET_STATE = "set-state", o.ON_CHANGE = "on-change", o.RESIZE = "resize", o))(D || {});
function z(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var N = { exports: {} }, k;
function K() {
  return k || (k = 1, function(o) {
    var t = (() => {
      var e = Object.defineProperty, i = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, a = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable, b = (f, c, p) => c in f ? e(f, c, { enumerable: !0, configurable: !0, writable: !0, value: p }) : f[c] = p, _ = (f, c) => {
        for (var p in c || (c = {}))
          l.call(c, p) && b(f, p, c[p]);
        if (a)
          for (var p of a(c))
            w.call(c, p) && b(f, p, c[p]);
        return f;
      }, g = (f, c) => {
        for (var p in c)
          e(f, p, { get: c[p], enumerable: !0 });
      }, I = (f, c, p, L) => {
        if (c && typeof c == "object" || typeof c == "function")
          for (let y of r(c))
            !l.call(f, y) && y !== p && e(f, y, { get: () => c[y], enumerable: !(L = i(c, y)) || L.enumerable });
        return f;
      }, x = (f) => I(e({}, "__esModule", { value: !0 }), f), n = (f, c, p) => (b(f, typeof c != "symbol" ? c + "" : c, p), p), E = {};
      g(E, {
        DEFAULT_OPTIONS: () => $,
        DEFAULT_UUID_LENGTH: () => S,
        default: () => R
      });
      var B = "5.2.0", S = 6, $ = {
        dictionary: "alphanum",
        shuffle: !0,
        debug: !1,
        length: S,
        counter: 0
      }, C = class {
        constructor(f = {}) {
          n(this, "counter"), n(this, "debug"), n(this, "dict"), n(this, "version"), n(this, "dictIndex", 0), n(this, "dictRange", []), n(this, "lowerBound", 0), n(this, "upperBound", 0), n(this, "dictLength", 0), n(this, "uuidLength"), n(this, "_digit_first_ascii", 48), n(this, "_digit_last_ascii", 58), n(this, "_alpha_lower_first_ascii", 97), n(this, "_alpha_lower_last_ascii", 123), n(this, "_hex_last_ascii", 103), n(this, "_alpha_upper_first_ascii", 65), n(this, "_alpha_upper_last_ascii", 91), n(this, "_number_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii]
          }), n(this, "_alpha_dict_ranges", {
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), n(this, "_alpha_lower_dict_ranges", {
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
          }), n(this, "_alpha_upper_dict_ranges", {
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), n(this, "_alphanum_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), n(this, "_alphanum_lower_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
          }), n(this, "_alphanum_upper_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), n(this, "_hex_dict_ranges", {
            decDigits: [this._digit_first_ascii, this._digit_last_ascii],
            alphaDigits: [this._alpha_lower_first_ascii, this._hex_last_ascii]
          }), n(this, "_dict_ranges", {
            _number_dict_ranges: this._number_dict_ranges,
            _alpha_dict_ranges: this._alpha_dict_ranges,
            _alpha_lower_dict_ranges: this._alpha_lower_dict_ranges,
            _alpha_upper_dict_ranges: this._alpha_upper_dict_ranges,
            _alphanum_dict_ranges: this._alphanum_dict_ranges,
            _alphanum_lower_dict_ranges: this._alphanum_lower_dict_ranges,
            _alphanum_upper_dict_ranges: this._alphanum_upper_dict_ranges,
            _hex_dict_ranges: this._hex_dict_ranges
          }), n(this, "log", (...s) => {
            const h = [...s];
            if (h[0] = `[short-unique-id] ${s[0]}`, this.debug === !0 && typeof console < "u" && console !== null)
              return console.log(...h);
          }), n(this, "_normalizeDictionary", (s, h) => {
            let d;
            if (s && Array.isArray(s) && s.length > 1)
              d = s;
            else {
              d = [];
              let u;
              this.dictIndex = u = 0;
              const m = `_${s}_dict_ranges`, v = this._dict_ranges[m];
              Object.keys(v).forEach((M) => {
                const O = M;
                for (this.dictRange = v[O], this.lowerBound = this.dictRange[0], this.upperBound = this.dictRange[1], this.dictIndex = u = this.lowerBound; this.lowerBound <= this.upperBound ? u < this.upperBound : u > this.upperBound; this.dictIndex = this.lowerBound <= this.upperBound ? u += 1 : u -= 1)
                  d.push(String.fromCharCode(this.dictIndex));
              });
            }
            return h && (d = d.sort(() => Math.random() - 0.5)), d;
          }), n(this, "setDictionary", (s, h) => {
            this.dict = this._normalizeDictionary(s, h), this.dictLength = this.dict.length, this.setCounter(0);
          }), n(this, "seq", () => this.sequentialUUID()), n(this, "sequentialUUID", () => {
            let s, h, d = "";
            s = this.counter;
            do
              h = s % this.dictLength, s = Math.trunc(s / this.dictLength), d += this.dict[h];
            while (s !== 0);
            return this.counter += 1, d;
          }), n(this, "rnd", (s = this.uuidLength || S) => this.randomUUID(s)), n(this, "randomUUID", (s = this.uuidLength || S) => {
            let h, d, u;
            if (s === null || typeof s > "u" || s < 1)
              throw new Error("Invalid UUID Length Provided");
            for (h = "", u = 0; u < s; u += 1)
              d = parseInt(
                (Math.random() * this.dictLength).toFixed(0),
                10
              ) % this.dictLength, h += this.dict[d];
            return h;
          }), n(this, "fmt", (s, h) => this.formattedUUID(s, h)), n(this, "formattedUUID", (s, h) => {
            const d = {
              $r: this.randomUUID,
              $s: this.sequentialUUID,
              $t: this.stamp
            };
            return s.replace(
              /\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g,
              (u) => {
                const m = u.slice(0, 2), v = parseInt(u.slice(2), 10);
                return m === "$s" ? d[m]().padStart(v, "0") : m === "$t" && h ? d[m](v, h) : d[m](v);
              }
            );
          }), n(this, "availableUUIDs", (s = this.uuidLength) => parseFloat(
            Math.pow([...new Set(this.dict)].length, s).toFixed(0)
          )), n(this, "approxMaxBeforeCollision", (s = this.availableUUIDs(this.uuidLength)) => parseFloat(
            Math.sqrt(Math.PI / 2 * s).toFixed(20)
          )), n(this, "collisionProbability", (s = this.availableUUIDs(this.uuidLength), h = this.uuidLength) => parseFloat(
            (this.approxMaxBeforeCollision(s) / this.availableUUIDs(h)).toFixed(20)
          )), n(this, "uniqueness", (s = this.availableUUIDs(this.uuidLength)) => {
            const h = parseFloat(
              (1 - this.approxMaxBeforeCollision(s) / s).toFixed(20)
            );
            return h > 1 ? 1 : h < 0 ? 0 : h;
          }), n(this, "getVersion", () => this.version), n(this, "stamp", (s, h) => {
            const d = Math.floor(+(h || /* @__PURE__ */ new Date()) / 1e3).toString(16);
            if (typeof s == "number" && s === 0)
              return d;
            if (typeof s != "number" || s < 10)
              throw new Error(
                [
                  "Param finalLength must be a number greater than or equal to 10,",
                  "or 0 if you want the raw hexadecimal timestamp"
                ].join(`
`)
              );
            const u = s - 9, m = Math.round(Math.random() * (u > 15 ? 15 : u)), v = this.randomUUID(u);
            return `${v.substring(0, m)}${d}${v.substring(m)}${m.toString(16)}`;
          }), n(this, "parseStamp", (s, h) => {
            if (h && !/t0|t[1-9]\d{1,}/.test(h))
              throw new Error("Cannot extract date from a formated UUID with no timestamp in the format");
            const d = h ? h.replace(
              /\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g,
              (m) => {
                const v = {
                  $r: (U) => [...Array(U)].map(() => "r").join(""),
                  $s: (U) => [...Array(U)].map(() => "s").join(""),
                  $t: (U) => [...Array(U)].map(() => "t").join("")
                }, M = m.slice(0, 2), O = parseInt(m.slice(2), 10);
                return v[M](O);
              }
            ).replace(
              /^(.*?)(t{8,})(.*)$/g,
              (m, v, M) => s.substring(v.length, v.length + M.length)
            ) : s;
            if (d.length === 8)
              return new Date(parseInt(d, 16) * 1e3);
            if (d.length < 10)
              throw new Error("Stamp length invalid");
            const u = parseInt(d.substring(d.length - 1), 16);
            return new Date(parseInt(d.substring(u, u + 8), 16) * 1e3);
          }), n(this, "setCounter", (s) => {
            this.counter = s;
          }), n(this, "validate", (s, h) => {
            const d = h ? this._normalizeDictionary(h) : this.dict;
            return s.split("").every((u) => d.includes(u));
          });
          const c = _(_({}, $), f);
          this.counter = 0, this.debug = !1, this.dict = [], this.version = B;
          const {
            dictionary: p,
            shuffle: L,
            length: y,
            counter: j
          } = c;
          return this.uuidLength = y, this.setDictionary(p, L), this.setCounter(j), this.debug = c.debug, this.log(this.dict), this.log(
            `Generator instantiated with Dictionary Size ${this.dictLength} and counter set to ${this.counter}`
          ), this.log = this.log.bind(this), this.setDictionary = this.setDictionary.bind(this), this.setCounter = this.setCounter.bind(this), this.seq = this.seq.bind(this), this.sequentialUUID = this.sequentialUUID.bind(this), this.rnd = this.rnd.bind(this), this.randomUUID = this.randomUUID.bind(this), this.fmt = this.fmt.bind(this), this.formattedUUID = this.formattedUUID.bind(this), this.availableUUIDs = this.availableUUIDs.bind(this), this.approxMaxBeforeCollision = this.approxMaxBeforeCollision.bind(this), this.collisionProbability = this.collisionProbability.bind(this), this.uniqueness = this.uniqueness.bind(this), this.getVersion = this.getVersion.bind(this), this.stamp = this.stamp.bind(this), this.parseStamp = this.parseStamp.bind(this), this;
        }
      };
      n(C, "default", C);
      var R = C;
      return x(E);
    })();
    o.exports = t.default, typeof window < "u" && (t = t.default);
  }(N)), N.exports;
}
var W = K();
const V = /* @__PURE__ */ z(W), T = new V({ length: 10 });
class q {
  constructor(t, e) {
    this.onMessageHandlers = [], this.message = (i, r, a) => this.crossOrigin ? this.postMessage(i, r, a) : this.customEventMessage(i, r, a), this.channelId = t ?? A, this.channelNodeId = `channel-node-${T.rnd()}`, this.crossOrigin = e, this.connection = new Promise((i) => {
      this.resolveConnection = i;
    }), this.boundMessageHandler = this.handleMessage.bind(this);
  }
  /**
   * Remove event listener from the window
   */
  disconnect() {
    this.onMessageHandlers = [], window.removeEventListener(this.channelId, this.boundMessageHandler), this.connection = new Promise((t) => {
      this.resolveConnection = t;
    });
  }
  /**
   * Takes a callback which gets triggered whenever an event is received.
   * All the message handlers are store in 'onMessageHandlers'.
   */
  onMessage(t) {
    this.onMessageHandlers.push(t);
  }
  /**
   * Removes a message handler from the 'onMessageHandlers' array.
   */
  removeMessageHandler(t) {
    const e = this.onMessageHandlers.findIndex(
      (i) => i === t
    );
    this.onMessageHandlers.splice(e, 1);
  }
  customEventMessage(t, e, i) {
    const r = new CustomEvent(this.channelId, {
      detail: {
        eventId: i,
        channelId: this.channelId,
        channelNodeId: this.channelNodeId,
        name: t,
        data: e
      }
    });
    window.dispatchEvent(r);
  }
  postMessage(t, e, i) {
    var r, a, l, w;
    if (!((r = this.crossOrigin) != null && r.targetOrigin)) {
      console.error("A target origin was not specified.");
      return;
    }
    (w = (a = this.crossOrigin) == null ? void 0 : a.window) == null || w.postMessage(
      {
        eventId: i,
        channelId: this.channelId,
        channelNodeId: this.channelNodeId,
        name: t,
        data: e
      },
      (l = this.crossOrigin) == null ? void 0 : l.targetOrigin
    );
  }
  /**
   * Sends a message event, and resolves when it receives a response. This is
   * similar to an HTTP request.
   */
  async eventRequest(t, e) {
    const i = T.rnd();
    return new Promise((r) => {
      const a = (l) => {
        const { eventId: w } = l;
        i === w && (this.removeMessageHandler(a), r(l));
      };
      this.onMessage(a), this.message(t, e, i);
    });
  }
  /**
   * A Promise wrapper around onMessage. 'waitForEvent' will resolve 'data' when
   * it receives an event corresponding to 'eventName'.
   */
  async waitForEvent(t) {
    return new Promise((e) => {
      const i = (r) => {
        const { name: a } = r;
        t === a && (this.removeMessageHandler(i), e(r));
      };
      this.onMessage(i);
    });
  }
  /**
   * Triggers the onMessageHandlers.
   */
  handleMessage(t) {
    var e;
    let i;
    if (q.isCustomEvent(t))
      i = t.detail;
    else {
      if (this.crossOrigin && !this.crossOrigin.targetOrigin.includes(t.origin) && // If the targetOrigin is set to "*", aka "wildcard", any event.origin
      // should be accepted.
      ((e = this.crossOrigin) == null ? void 0 : e.targetOrigin) !== "*")
        return;
      i = t.data;
    }
    const {
      channelId: r,
      channelNodeId: a
    } = i;
    this.channelId === r && this.channelNodeId !== a && this.onMessageHandlers.forEach((l) => {
      l(i);
    });
  }
  static isCustomEvent(t) {
    return t.detail !== void 0;
  }
}
class G extends q {
  connect(t) {
    return window.addEventListener(
      this.crossOrigin ? "message" : this.channelId,
      this.boundMessageHandler
    ), this.waitForEvent(F).then((e) => {
      this.message(
        "CONNECTION_EVENT_RESPONSE",
        t,
        e.eventId
      ), this.resolveConnection(e);
    }), this.connection;
  }
}
const Q = new Error("request for lock canceled");
var Z = function(o, t, e, i) {
  function r(a) {
    return a instanceof e ? a : new e(function(l) {
      l(a);
    });
  }
  return new (e || (e = Promise))(function(a, l) {
    function w(g) {
      try {
        _(i.next(g));
      } catch (I) {
        l(I);
      }
    }
    function b(g) {
      try {
        _(i.throw(g));
      } catch (I) {
        l(I);
      }
    }
    function _(g) {
      g.done ? a(g.value) : r(g.value).then(w, b);
    }
    _((i = i.apply(o, t || [])).next());
  });
};
class Y {
  constructor(t, e = Q) {
    this._value = t, this._cancelError = e, this._queue = [], this._weightedWaiters = [];
  }
  acquire(t = 1, e = 0) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return new Promise((i, r) => {
      const a = { resolve: i, reject: r, weight: t, priority: e }, l = P(this._queue, (w) => e <= w.priority);
      l === -1 && t <= this._value ? this._dispatchItem(a) : this._queue.splice(l + 1, 0, a);
    });
  }
  runExclusive(t) {
    return Z(this, arguments, void 0, function* (e, i = 1, r = 0) {
      const [a, l] = yield this.acquire(i, r);
      try {
        return yield e(a);
      } finally {
        l();
      }
    });
  }
  waitForUnlock(t = 1, e = 0) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return this._couldLockImmediately(t, e) ? Promise.resolve() : new Promise((i) => {
      this._weightedWaiters[t - 1] || (this._weightedWaiters[t - 1] = []), J(this._weightedWaiters[t - 1], { resolve: i, priority: e });
    });
  }
  isLocked() {
    return this._value <= 0;
  }
  getValue() {
    return this._value;
  }
  setValue(t) {
    this._value = t, this._dispatchQueue();
  }
  release(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    this._value += t, this._dispatchQueue();
  }
  cancel() {
    this._queue.forEach((t) => t.reject(this._cancelError)), this._queue = [];
  }
  _dispatchQueue() {
    for (this._drainUnlockWaiters(); this._queue.length > 0 && this._queue[0].weight <= this._value; )
      this._dispatchItem(this._queue.shift()), this._drainUnlockWaiters();
  }
  _dispatchItem(t) {
    const e = this._value;
    this._value -= t.weight, t.resolve([e, this._newReleaser(t.weight)]);
  }
  _newReleaser(t) {
    let e = !1;
    return () => {
      e || (e = !0, this.release(t));
    };
  }
  _drainUnlockWaiters() {
    if (this._queue.length === 0)
      for (let t = this._value; t > 0; t--) {
        const e = this._weightedWaiters[t - 1];
        e && (e.forEach((i) => i.resolve()), this._weightedWaiters[t - 1] = []);
      }
    else {
      const t = this._queue[0].priority;
      for (let e = this._value; e > 0; e--) {
        const i = this._weightedWaiters[e - 1];
        if (!i)
          continue;
        const r = i.findIndex((a) => a.priority <= t);
        (r === -1 ? i : i.splice(0, r)).forEach((a) => a.resolve());
      }
    }
  }
  _couldLockImmediately(t, e) {
    return (this._queue.length === 0 || this._queue[0].priority < e) && t <= this._value;
  }
}
function J(o, t) {
  const e = P(o, (i) => t.priority <= i.priority);
  o.splice(e + 1, 0, t);
}
function P(o, t) {
  for (let e = o.length - 1; e >= 0; e--)
    if (t(o[e]))
      return e;
  return -1;
}
var X = function(o, t, e, i) {
  function r(a) {
    return a instanceof e ? a : new e(function(l) {
      l(a);
    });
  }
  return new (e || (e = Promise))(function(a, l) {
    function w(g) {
      try {
        _(i.next(g));
      } catch (I) {
        l(I);
      }
    }
    function b(g) {
      try {
        _(i.throw(g));
      } catch (I) {
        l(I);
      }
    }
    function _(g) {
      g.done ? a(g.value) : r(g.value).then(w, b);
    }
    _((i = i.apply(o, t || [])).next());
  });
};
class tt {
  constructor(t) {
    this._semaphore = new Y(1, t);
  }
  acquire() {
    return X(this, arguments, void 0, function* (t = 0) {
      const [, e] = yield this._semaphore.acquire(1, t);
      return e;
    });
  }
  runExclusive(t, e = 0) {
    return this._semaphore.runExclusive(() => t(), 1, e);
  }
  isLocked() {
    return this._semaphore.isLocked();
  }
  waitForUnlock(t = 0) {
    return this._semaphore.waitForUnlock(1, t);
  }
  release() {
    this._semaphore.isLocked() && this._semaphore.release();
  }
  cancel() {
    return this._semaphore.cancel();
  }
}
class et {
  constructor(t, e, i) {
    this.onMessageHandlers = [], this.leaderNode = new G(
      e ?? "ll-state-manager",
      i
    ), this.leaderNode.connect(t), this.defaultState = t, this.isConnected = this.leaderNode.connection, this.clientLock = new tt();
  }
  async setState(t) {
    await this.leaderNode.connection;
    const e = await this.clientLock.acquire(), i = await this.getState(), r = t(i);
    this.leaderNode.message(D.SET_STATE, r), e();
  }
  async getState() {
    return await this.leaderNode.connection, (await this.leaderNode.eventRequest(
      D.GET_STATE
    )).data;
  }
  async onChange(t) {
    await this.leaderNode.connection, this.leaderNode.onMessage((e) => {
      e.name === D.ON_CHANGE && t(e.data);
    });
  }
  destroy() {
    this.leaderNode.disconnect();
  }
}
function H(o) {
  const t = {};
  return Promise.race([o, t]).then(
    (e) => e === t ? "pending" : "fulfilled",
    () => "rejected"
  );
}
class it {
  constructor(t, e, i, r = {
    lazy: !0,
    buildId: "v1"
  }) {
    this.options = i, this.renderTo = e, this.sdkBuildId = r.buildId || "v1", this.hasMounted = new Promise((a, l) => {
      this.hasMountedResolve = a, this.hasMountedReject = l;
    }), this.renderTo.style.position = "relative", r.lazy ? (this.renderHandler = async () => {
      const a = await H(this.hasMounted);
      this.isInViewport() && a === "pending" && (this.renderedElement = this.mount(t, e), clearInterval(this.lazyInterval));
    }, this.renderHandler(), this.lazyInterval = setInterval(this.renderHandler, 200)) : this.renderedElement = this.mount(t, e);
  }
  async update(t) {
    var e;
    await this.hasMounted, (e = this.stateManager) == null || e.setState((i) => ({
      ...i,
      options: {
        ...i.options,
        ...t
      }
    }));
  }
  async on(t, e) {
    var i;
    await this.hasMounted, t === "change" && ((i = this.stateManager) == null || i.onChange(e));
  }
  async destroy() {
    var t, e;
    await H(this.hasMounted), this.hasMountedReject("SDK has already been destroyed."), this.renderHandler && document.removeEventListener("scroll", this.renderHandler), (t = this.stateManager) == null || t.destroy(), (e = this.renderedElement) == null || e.remove();
  }
  mount(t, e) {
    var I, x, n, E;
    this.hasMountedResolve();
    const i = (x = (I = this.options.globalOptions) == null ? void 0 : I.environment) == null ? void 0 : x.sdk;
    typeof ((E = (n = this.options.globalOptions) == null ? void 0 : n.environment) == null ? void 0 : E.sdk) < "u" && typeof i > "u" && console.warn(
      "Invalid SDK environment defined. Using production instead."
    );
    const r = `chn-${Math.random() * 100}`, a = {
      dev: "http://localhost:3001",
      qa: "https://staging.locallogic.co",
      prod: "https://sdk.locallogic.co"
    };
    let l = a.prod;
    Object.keys(a).includes(i) && (l = a[i]);
    const w = `sdks-app/${this.sdkBuildId}/${String(t)}?channelId=${r}`, b = `${l}/${w}`, _ = document.createElement("iframe");
    _.src = b, _["data-testid"] = "locallogic-sdk-iframe", _.name = "Local Logic SDK", _.title = "Local Logic SDK", _.style.cssText = `
    width: 100%;
    height: 100%;
    border: 0;
    `, e.appendChild(_);
    const { contentWindow: g } = _;
    return this.stateManager = new et(this.options, r, {
      targetOrigin: l,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      window: g
    }), this.handleResize(_), _;
  }
  isInViewport() {
    const t = this.renderTo.getBoundingClientRect();
    return (window.innerHeight || document.documentElement.clientHeight) - t.top >= -350;
  }
  handleResize(t) {
    var e;
    (e = this.stateManager) == null || e.leaderNode.onMessage((i) => {
      if (i.name === D.RESIZE) {
        const r = t;
        r.style.cssText = `height: ${i.data.scrollHeight}px !important; width: 100%; border: 0;`;
      }
    });
  }
}
class st {
  constructor(t, e, i) {
    this.registeredSDKs = [], this.apiKey = t, this.globalOptions = e, this.buildId = i || "v1";
  }
  create(t, e, i, r) {
    const a = new it(
      t,
      e,
      {
        apiKey: this.apiKey,
        globalOptions: this.globalOptions,
        options: i
      },
      {
        lazy: (r == null ? void 0 : r.lazy) || !0,
        buildId: this.buildId
      }
    );
    return this.registeredSDKs.push(a), a;
  }
  update(t) {
    this.registeredSDKs.forEach(async (e) => {
      var i;
      await e.hasMounted, (i = e.stateManager) == null || i.setState((r) => ({
        ...r,
        globalOptions: {
          ...r.globalOptions,
          ...t
        }
      }));
    });
  }
}
const nt = (o, t, e) => new st(o, t, e);
export {
  nt as default
};
